import React from 'react'
import styledComponents from 'styled-components'
import { Icon } from 'react-icons-kit'

const Button = styledComponents.button.attrs({
  className: props => props.className ? props.className: 'button',
})`
  > *:first-child {
    ${({ hasTitle }) => (hasTitle ? `margin-right: 8px;` : null)}
  }
`

export default ({ icon, children, ...props }) => (
  <Button {...props} hasTitle={children !== undefined}>
    <Icon icon={icon} /> {children}
  </Button>
)



// WEBPACK FOOTER //
// ./src/components/views/buttons/IconButton.js